'use strict';

var map = require('map-obj');

var _require = require('snake-case'),
    snakeCase = _require.snakeCase;

module.exports = function (obj, options) {
  options = Object.assign({
    deep: true,
    exclude: []
  }, options);
  return map(obj, function (key, val) {
    return [matches(options.exclude, key) ? key : snakeCase(key), val];
  }, options);
};

function matches(patterns, value) {
  return patterns.some(function (pattern) {
    return typeof pattern === 'string' ? pattern === value : pattern.test(value);
  });
}